import React from 'react';
import Hero from './Hero';
import Services from './Services';
import About from './About';
import TrustBadges from './TrustBadges';
import Projects from './Projects';
import CTASection from './CTASection';

const Home = () => {
  return (
    <main>
      <Hero />
      <Services />
      <About />
      <TrustBadges />
      <Projects />
      <CTASection />
    </main>
  );
};

export default Home;